const config = {
  env: 'production',
  baseUrl: 'https://api.dimorder.com',
  nodeApiUrl: 'https://node.dimorder.com',
  basePriceUrl: 'https://delivery-price.dimorder.com',
}

export default config
